<template>
    <div v-show="isActive" :id="hash" :aria-hidden="!isActive" class="dk-tab">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'DkTabDST',
    props: {
        id: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            required: true,
        },
        prefix: {
            type: String,
            default: '',
        },
        suffix: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isActive: false,
            isVisible: true,
        };
    },
    computed: {
        header() {
            return `${this.prefix}${this.name}${this.suffix}`;
        },
        computedId() {
            return this.id ? `${this.id}` : `${this.name.toLowerCase().replace(/ /g, '-')}`;
        },
        hash() {
            if (this.disabled) {
                return '#';
            }

            return `#${this.computedId}`;
        },
    },
};
</script>
